var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1552 4.40674L22.1027 4.52924L17.0277 16.3067H12.0402C10.8502 16.3067 9.71268 16.5517 8.68018 16.9892L11.7427 9.67424L11.8127 9.49924L11.9352 9.21924C11.9702 9.11424 12.0052 9.00924 12.0577 8.92174C14.3502 3.61924 16.9402 2.41174 22.1552 4.40674Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5873 16.6567C30.7998 16.4117 29.9598 16.3067 29.1198 16.3067H17.0273L22.1023 4.52924L22.1548 4.40674C22.4173 4.49424 22.6623 4.61674 22.9248 4.72174L26.7923 6.34924C28.9448 7.24174 30.4498 8.16924 31.3598 9.28924C31.5348 9.49924 31.6748 9.69174 31.7973 9.91924C31.9548 10.1642 32.0773 10.4092 32.1473 10.6717C32.2173 10.8292 32.2698 10.9867 32.3048 11.1267C32.7773 12.5967 32.4973 14.3992 31.5873 16.6567Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.663 24.8471V28.2596C37.663 28.6096 37.6455 28.9596 37.628 29.3096C37.2955 35.4171 33.883 38.4971 27.408 38.4971H13.758C13.338 38.4971 12.918 38.4621 12.5155 38.4096C6.95051 38.0421 3.97551 35.0671 3.60801 29.5021C3.55551 29.0996 3.52051 28.6796 3.52051 28.2596V24.8471C3.52051 21.3296 5.65551 18.3021 8.70051 16.9896C9.75051 16.5521 10.8705 16.3071 12.0605 16.3071H29.1405C29.998 16.3071 30.838 16.4296 31.608 16.6571C35.0905 17.7246 37.663 20.9796 37.663 24.8471Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7425 9.67432L8.68 16.9893C5.635 18.3018 3.5 21.3293 3.5 24.8468V19.7193C3.5 14.7493 7.035 10.6018 11.7425 9.67432Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6575 19.7184V24.8459C37.6575 20.9959 35.1025 17.7234 31.6025 16.6734C32.5125 14.3984 32.775 12.6134 32.3375 11.1259C32.3025 10.9684 32.25 10.8109 32.18 10.6709C35.435 12.3509 37.6575 15.7984 37.6575 19.7184Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostCategory);
export default __webpack_public_path__ + "static/media/cost_category.5b7b4aef91463cf9f2caf74cebabe3aa.svg";
export { ForwardRef as ReactComponent };